import "./styles.css";

const Form = ({ onSubmit, children, readOnly, activateForm, isSubmitting }) => {
  return (
    <form className="form__container" onSubmit={onSubmit}>
      {children}

      {!readOnly && (
        <div className="form__submit--container">
          <button className="form__submit--button" disabled={isSubmitting}>
            {!isSubmitting ? "SUBMIT" : "Submitting"}
          </button>

          {activateForm && (
            <div className="form__cancel--button" onClick={() => activateForm(false)}>
              CANCEL
            </div>
          )}
        </div>
      )}
    </form>
  )
};

export default Form;